<template>
  <div class="spinner text-center flex justify-center items-center text-cyan-300" :class="`${textSizes[size]}`">
    <div class="spinner-animation-target flex justify-center items-center">
      <i class="sr-2 sr-v2-spinner"></i>
    </div>
  </div>
</template>

<script>
  import { dsTextSizes } from '@/srui';
  export default {
    name: 'Spinner',

    props: {
      size: { type: String, default: '6xl' }
    },
    data() {
      return {
        textSizes: {
          ...dsTextSizes
        }
      }
    }
  }
</script>

<style scoped>
.spinner {
  margin: 0 auto;
  text-align: center;
  border-left-color: #fff; 
}

.spinner-animation-target {
  animation: spin 1.1s infinite linear;
}

@keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
</style>
